(function () {
    'use strict';

    angular.module("imApp").factory("custactCustomerService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1170,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1171,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
